export default __webpack_public_path__ + "static/media/logo_head_jbf.efa95c13.png";